const mediaQueries = {
  mobile: 0,
  tablet: 768,
  desktop: 1278,
};

const device = {
  create: (breakpoints = mediaQueries) => ({
    isMobile() {
      return this.isSmaller('tablet');
    },

    isTablet() {
      return this.isAtLeast('tablet') && this.isSmaller('desktop');
    },

    isDesktop() {
      return this.isAtLeast('desktop');
    },

    isSmaller(rule) {
      return this._getInnerWidth() < this._getSizeFromMediaQuery(rule);
    },

    isLarger(rule) {
      return this._getInnerWidth() > this._getSizeFromMediaQuery(rule);
    },

    isAtMost(rule) {
      return this._getInnerWidth() <= this._getSizeFromMediaQuery(rule);
    },

    isAtLeast(rule) {
      return this._getInnerWidth() >= this._getSizeFromMediaQuery(rule);
    },

    _getSizeFromMediaQuery(rule) {
      return breakpoints[rule] || parseInt(rule, 10);
    },

    _getInnerWidth() {
      return typeof window !== 'undefined' ? window.innerWidth : 0; //SSR
    },
  }),
};

export { device as default };
//# sourceMappingURL=device.js.map
